
























































































































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import {
  FormBuilderField,
  SelectedField,
  FormBuilderTab,
} from "../types/FormBuilderTypes";
import { ComponentsTypes } from "@/components/DinamicallyForm/TipoComponentes";
import IconSelector from "@/components/IconSelector/IconSelector.vue";
import AddTabDialog from "./dialogs/AddTabDialog.vue";
import DatasourceConfigDialog, {
  DatasourceConfig,
} from "./dialogs/DatasourceConfigDialog.vue";
import FormApiConfigDialog, {
  FormApiConfig,
} from "./dialogs/FormApiConfigDialog.vue";

@Component({
  components: {
    IconSelector,
    AddTabDialog,
    DatasourceConfigDialog,
    FormApiConfigDialog,
  },
})
export default class PropertiesPanel extends Vue {
  @Prop({ required: true }) selectedField!: SelectedField;
  @Prop({ required: true }) tabs!: FormBuilderTab[];

  public localField: FormBuilderField | null = null;
  public showAddTabDialog: boolean = false;
  public showDatasourceDialog: boolean = false;
  public showFormApiDialog: boolean = false;
  public showIconSelector: boolean = false;
  public ComponentsTypes = ComponentsTypes;

  public datasourceConfig: DatasourceConfig = {
    apiEndpoint: "",
    displayExpr: "text",
    valueExpr: "value",
    endpointType: "backend",
  };

  public formApiConfig: FormApiConfig = {
    getEndpoint: "",
    saveEndpoint: "",
    deleteEndpoint: "",
  };

  public datatypeOptions = [
    { text: "Texto (string)", value: "string" },
    { text: "Número (number)", value: "number" },
    { text: "Booleano (boolean)", value: "boolean" },
    { text: "Fecha (date)", value: "date" },
    { text: "Fecha y Hora (datetime)", value: "datetime" },
  ];

  @Watch("selectedField", { deep: true, immediate: true })
  onSelectedFieldChanged(newVal: SelectedField) {
    if (newVal && newVal.field) {
      this.localField = JSON.parse(JSON.stringify(newVal.field));

      // Load existing datasource config if exists
      if (this.localField && this.localField.comboConfig) {
        const comboConfig = this.localField.comboConfig;
        this.datasourceConfig = {
          apiEndpoint: comboConfig.apiEndpoint || "",
          displayExpr: comboConfig.displayExpr || "text",
          valueExpr: comboConfig.valueExpr || "value",
          endpointType: comboConfig.endpointType || "backend",
        };
      } else {
        // Reset datasource config
        this.datasourceConfig = {
          apiEndpoint: "",
          displayExpr: "text",
          valueExpr: "value",
          endpointType: "backend",
        };
      }
    } else {
      this.localField = null;
    }
  }

  public get tabOptions() {
    return this.tabs.map((tab) => ({
      text: `Tab ${tab.tabNumber}: ${tab.tabName}`,
      value: tab.tabNumber,
    }));
  }

  public get hasComponentSpecificProps(): boolean {
    if (!this.localField) return false;
    return [
      ComponentsTypes.Switch,
      ComponentsTypes.Date,
      ComponentsTypes.DateTime,
      ComponentsTypes.SingleCombo,
      ComponentsTypes.MultiCombo,
      ComponentsTypes.RadioButton,
    ].includes(this.localField.componentType);
  }

  public get hasFormApiConfig(): boolean {
    return false; // TODO: Get from parent
  }

  public emitUpdate() {
    if (this.localField) {
      this.$emit("update-field", this.localField);
    }
  }

  public deleteField() {
    if (this.localField) {
      this.$emit("delete-field", this.localField.id);
    }
  }

  public addTab(tabName: string) {
    this.$emit("add-tab", tabName);
  }

  public openDatasourceDialog() {
    this.showDatasourceDialog = true;
  }

  public onDatasourceSaved(config: DatasourceConfig) {
    if (this.localField && this.localField.comboConfig) {
      this.localField.comboConfig.apiEndpoint = config.apiEndpoint;
      this.localField.comboConfig.displayExpr = config.displayExpr;
      this.localField.comboConfig.valueExpr = config.valueExpr;
      this.localField.comboConfig.endpointType = config.endpointType;
      this.datasourceConfig = config;
      this.emitUpdate();
    }
  }

  public onFormApiSaved(config: FormApiConfig) {
    this.formApiConfig = config;
    this.$emit("update-form-api", config);
  }

  public onIconSelected(icon: string) {
    if (this.localField) {
      this.localField.icon = icon;
      this.emitUpdate();
      this.showIconSelector = false;
    }
  }
}
